var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.277344 13.5C0.277344 6.3203 6.09764 0.5 13.2773 0.5C20.457 0.5 26.2773 6.3203 26.2773 13.5C26.2773 20.6797 20.457 26.5 13.2773 26.5C6.09764 26.5 0.277344 20.6797 0.277344 13.5Z",
    fill: "#00762A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_23193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9819 16.2755L8.49668 13.7903C8.21736 13.5109 7.76615 13.5109 7.48683 13.7903C7.20751 14.0696 7.20751 14.5208 7.48683 14.8001L10.4806 17.7938C10.7599 18.0732 11.2111 18.0732 11.4904 17.7938L19.0679 10.2164C19.3472 9.93709 19.3472 9.48588 19.0679 9.20656C18.7885 8.92724 18.3373 8.92724 18.058 9.20656L10.9819 16.2755Z",
    fill: "#DDF8E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_23193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(7.27734 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9d86c321089a73354de110a35f49210b.svg";
export { ForwardRef as ReactComponent };